import React, { Component } from 'react';

import Radio from './Radio/Radio';
import classes from './RadioGroup.module.css';
import PropTypes from 'prop-types';

class RadioGroup extends Component {
  _setValue = (value) => {
    this.props.radioClicked(value);
  }

  _renderRadios = () => {
    let longestText = '';
    this.props.options.map((o) => {
      if (longestText.length < o.text.length) {
        longestText = o.text;
      }
      return null;
    });
    return this.props.options.map((o, i) => {
      return (
        <Radio
          key={i}
          optionText={o.text}
          optionValue={o.value}
          selected={o.value === this.props.selected}
          radioClicked={this._setValue.bind(this, o.value)}
          largerRadio={this.props.largerRadio}
          longestText={longestText}
          isLandscape={this.props.isLandscape}
        />
      );
    });
  }

  render () {
    // console.log('//////// RADIO RENDERS ', this.props);
    return (
      <div className={classes.RadioGroup} style={this.props.style}>
        {this._renderRadios()}
      </div>
    );
  }
}

RadioGroup.propTypes = {
  options: PropTypes.array.isRequired,
  selected: PropTypes.number.isRequired,
  radioClicked: PropTypes.func.isRequired
};

RadioGroup.defaultProps = {
  style: {}
};

export default RadioGroup;
